import AsoHeader from "../../../components/Aso/Header";
import DocumentoAssinadoSucesso from "../../../components/Aso/Register/AsoDocumentoAssinadoSucesso";

const AsoDocumentoAssinadoSucesso = () => {
    return(
        <>
            <AsoHeader />
            <DocumentoAssinadoSucesso />
        </>
    );
}

export default AsoDocumentoAssinadoSucesso;